import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportService } from '../report.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-practical-marks-report',
  templateUrl: './practical-marks-report.component.html',
  styleUrls: ['./practical-marks-report.component.scss']
})
export class PracticalMarksReportComponent implements OnInit {

  PracticalReport: FormGroup;

  userPermission: any;
  userId: number | null = null;
  UserCollege: any;

  sessionList: any[] = [];
  SessionFilterList: any[] = [];

  CourseList: any[] = [];
  filteredCourseList: any[] = [];

  collegeList: any[] = [];
  filteredCollegeList: any[] = [];

  ExamAList: any[] = [];
  filteredExamAList: any[] = [];

  BranchList: any[] = [];
  filteredBranchList: any[] = [];

  selectedColleges: string[] = [];
  commaSeparatedColleges: string = '';

  isDownloadingExcel = false;
  showDownloadButton = false;

  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.fetchSessions();

    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    this.userId = this.userPermission.length ? this.userPermission[0].UserId : null;
  }

  initializeForm(): void {
    this.PracticalReport = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      course:    new FormControl({ value: '', disabled: true }, Validators.required),
      college:   new FormControl({ value: [], disabled: true }, Validators.required),
      Exam:      new FormControl({ value: '', disabled: true }, Validators.required),
      Branch:    new FormControl({ value: '', disabled: true })
    });

    // ---------- Session ----------
    this.PracticalReport.get('SessionId').valueChanges.subscribe((value: string) => {
      if (value) {
        this.PracticalReport.get('course').enable();
        this.fetchCourses();
        this.resetDependentFields(['college', 'Exam', 'Branch']);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
      } else {
        this.PracticalReport.get('course').disable();
        this.PracticalReport.get('college').disable();
        this.PracticalReport.get('Exam').disable();
        this.PracticalReport.get('Branch').disable();

        this.resetDependentFields(['course', 'college', 'Exam', 'Branch']);
        this.CourseList = [];
        this.filteredCourseList = [];
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
      }
      this.updateDownloadButtonVisibility();
    });

    // ---------- Course ----------
    this.PracticalReport.get('course').valueChanges.subscribe((value: string) => {
      if (value) {
        this.PracticalReport.get('college').enable();
        this.fetchColleges();
        this.resetDependentFields(['Exam', 'Branch']);
      } else {
        this.PracticalReport.get('college').disable();
        this.PracticalReport.get('college').setValue([]);
        this.resetDependentFields(['Exam', 'Branch']);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
      }
      this.updateDownloadButtonVisibility();
    });

    this.PracticalReport.get('college').valueChanges.subscribe((value: string[]) => {
      if (value && value.length > 0) {
        this.PracticalReport.get('Exam').enable();
        this.fetchExams();
      } else {
        this.PracticalReport.get('Exam').disable();
        this.PracticalReport.get('Exam').setValue('');
        this.resetDependentFields(['Branch']);
      }
      this.updateDownloadButtonVisibility();
    });

    this.PracticalReport.get('Exam').valueChanges.subscribe((value: string) => {
      if (value) {
        this.fetchBranches(value);
      } else {
        this.resetDependentFields(['Branch']);
      }
      this.updateDownloadButtonVisibility();
    });

    this.PracticalReport.get('Branch').valueChanges.subscribe(() => {
      this.updateDownloadButtonVisibility();
    });
  }

  fetchSessions(): void {
    this.spinner.show();
    this.umsService.getSession({}).subscribe((res) => {
      if (res.status) {
        this.sessionList = res.data.filter((item: any) => item.SnStatus === 'O');
        this.SessionFilterList = this.sessionList.slice();
      } else {
        this.sessionList = [];
        this.SessionFilterList = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching sessions:', error);
      this.spinner.hide();
    });
  }

  fetchCourses(): void {
    const sessionId = this.PracticalReport.get('SessionId').value;
    if (!sessionId) return;

    this.spinner.show();
    this.umsService.getSessionColgCo({ SessionID: sessionId }).subscribe((res) => {
      if (res.status) {
        const uniqueCourses = res.data.filter((course: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.CoCgCoCode === course.CoCgCoCode)
        );
        this.CourseList = uniqueCourses;
        this.filteredCourseList = this.CourseList.slice();
        this.PracticalReport.get('course').setValue('');
      } else {
        this.CourseList = [];
        this.filteredCourseList = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching courses:', error);
      this.spinner.hide();
    });
  }

  fetchColleges(): void {
    const courseCode = this.PracticalReport.get('course').value;
    if (!courseCode) return;

    this.spinner.show();

    this.UserCollege = this.userPermission[0]?.CgUi === 'C'
      ? this.userPermission[0].CgId
      : '';

    const payload = { CoCode: courseCode };

    this.umsService.fetchstucourseClgMap(payload).subscribe((res) => {
      if (res.status && res.data) {
        this.collegeList = res.data;

        if (this.UserCollege) {
          this.collegeList = this.collegeList.filter(college =>
            college.CgCode === this.UserCollege
          );
        }

        this.filteredCollegeList = this.collegeList.slice();

        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.PracticalReport.get('college').setValue([]);

        if (this.collegeList.length === 1) {
          this.selectedColleges = [this.collegeList[0].CgCode];
          this.commaSeparatedColleges = this.selectedColleges.join(',');
          this.PracticalReport.get('college').setValue(this.selectedColleges);
        }
      } else {
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.PracticalReport.get('college').setValue([]);
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching colleges:', error);
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.selectedColleges = [];
      this.commaSeparatedColleges = '';
      this.PracticalReport.get('college').setValue([]);
      this.spinner.hide();
    });
  }

  selectAllColleges(): void {
    if (this.isAllSelected()) {
      this.selectedColleges = [];
      this.PracticalReport.get('college').setValue([], { emitEvent: false });
      this.commaSeparatedColleges = '';
      this.PracticalReport.get('Exam').disable();
      this.PracticalReport.get('Exam').setValue('');
      this.resetDependentFields(['Branch']);
    } else {
      this.selectedColleges = this.filteredCollegeList.map(item => item.CgCode);
      this.PracticalReport.get('college').setValue(this.selectedColleges, { emitEvent: false });
      this.commaSeparatedColleges = this.selectedColleges.join(',');
      this.PracticalReport.get('Exam').enable();
      this.fetchExams();
    }
    this.updateDownloadButtonVisibility();
  }

  onCollegeSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');

    this.selectedColleges = selected;
    this.PracticalReport.get('college').setValue(selected, { emitEvent: false });
    this.commaSeparatedColleges = this.selectedColleges.join(',');

    if (selected.length > 0) {
      this.PracticalReport.get('Exam').enable();
      this.fetchExams();
    } else {
      this.PracticalReport.get('Exam').disable();
      this.PracticalReport.get('Exam').setValue('');
      this.resetDependentFields(['Branch']);
    }
    this.updateDownloadButtonVisibility();
  }

  isAllSelected(): boolean {
    return this.selectedColleges.length === this.filteredCollegeList.length
      && this.filteredCollegeList.length > 0;
  }

  isAllCollegesSelected(): boolean { return this.isAllSelected(); }

  isIndeterminate(): boolean {
    return this.selectedColleges.length > 0
      && this.selectedColleges.length < this.filteredCollegeList.length;
  }

  fetchExams(): void {
    const courseCode = this.PracticalReport.get('course').value;
    const sessionId  = this.PracticalReport.get('SessionId').value;
    if (!courseCode || !sessionId) return;

    this.spinner.show();
    const payload = { EmCoCode: courseCode, SnNo: sessionId };

    this.umsService.getExam(payload).subscribe((res) => {
      if (res.status && res.data && res.data.length > 0) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamAList = [];
        this.PracticalReport.get('Exam').setValue('');
      }
      this.spinner.hide();
      this.updateDownloadButtonVisibility();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching exams:', error);
      this.ExamAList = [];
      this.filteredExamAList = [];
      this.PracticalReport.get('Exam').setValue('');
      this.spinner.hide();
      this.updateDownloadButtonVisibility();
    });
  }

  fetchBranches(examId: string): void {
    if (!examId) return;

    const exam = this.ExamAList.find(e => e.EmId === examId);

    if (!exam || exam.EmStreams !== 'Y') {
      this.BranchList = [];
      this.filteredBranchList = [];
      this.PracticalReport.get('Branch').setValue('');
      this.PracticalReport.get('Branch').disable();
      return;
    }

    this.spinner.show();

    this.umsService.getExamStream({ EmId: examId }).subscribe((res) => {
      this.spinner.hide();
      if (res.status && res.data && res.data.length > 0) {
        this.BranchList = res.data;
        this.filteredBranchList = this.BranchList.slice();
        this.PracticalReport.get('Branch').enable();
        this.PracticalReport.get('Branch').setValue(this.BranchList[0].StrId);
      } else {
        this.BranchList = [];
        this.filteredBranchList = [];
        this.PracticalReport.get('Branch').setValue('');
        this.PracticalReport.get('Branch').disable();
      }
      this.updateDownloadButtonVisibility();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching branches:', error);
      this.BranchList = [];
      this.filteredBranchList = [];
      this.PracticalReport.get('Branch').setValue('');
      this.PracticalReport.get('Branch').disable();
      this.spinner.hide();
      this.updateDownloadButtonVisibility();
    });
  }

  showBranchField(): boolean {
    const examId = this.PracticalReport.get('Exam').value;
    if (!examId) return false;
    const exam = this.ExamAList.find(e => e.EmId === examId);
    return exam ? exam.EmStreams === 'Y' : false;
  }

  onExamChange(examId: string): void {
    if (examId) {
      this.fetchBranches(examId);
    } else {
      this.BranchList = [];
      this.filteredBranchList = [];
      this.PracticalReport.get('Branch').setValue('');
      this.PracticalReport.get('Branch').disable();
    }
  }


  downloadPracticalMarksReportExcel(): void {
    if (this.PracticalReport.invalid) {
      this.markFormGroupTouched(this.PracticalReport);
      return;
    }

    this.isDownloadingExcel = true;
    this.spinner.show();

    const formData = this.PracticalReport.getRawValue();

    const cgCode = this.commaSeparatedColleges ||
      (Array.isArray(formData.college) ? formData.college.join(',') : formData.college);

    const payload = {
      SessionId: Number(formData.SessionId),
      EmId:      Number(formData.Exam),
      CoCode:    String(formData.course),
      CgCode:    String(cgCode || ''),
      Preview:   0
    };

    console.log('Fetching Practical Marks Excel with payload:', payload);

    this.umsService.getPracticalMarksExcel(payload).subscribe({
      next: (res: any) => {
        this.isDownloadingExcel = false;
        this.spinner.hide();

        if (res && res.status && Array.isArray(res.data) && res.data.length > 0) {
          this.exportPracticalMarksToExcel(res.data);
        } else {
          console.warn('No data:', res?.message);
          window.alert(res?.message || 'No data found for the selected filters.');
        }
      },
      error: (err: any) => {
        this.isDownloadingExcel = false;
        this.spinner.hide();
        console.error('Excel fetch error:', err);
        window.alert('Failed to generate Excel. Please try again.');
      }
    });
  }


  private exportPracticalMarksToExcel(rows: any[]): void {
    const ws = XLSX.utils.json_to_sheet(rows, { skipHeader: false });

    const headers = Object.keys(rows[0] || {});
    ws['!cols'] = headers.map(h => ({
      wch: Math.max(12, Math.min(40, h.length + 2))
    }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Practical Marks');

    const fileName = `PracticalMarksReport_${new Date().getTime()}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  private updateDownloadButtonVisibility(): void {
    const v = this.PracticalReport.getRawValue();   // include disabled controls
    this.showDownloadButton =
      !!v.SessionId &&
      !!v.course &&
      Array.isArray(v.college) && v.college.length > 0 &&
      !!v.Exam;
  }

  private resetDependentFields(fieldsToReset: string[]): void {
    fieldsToReset.forEach(field => {
      const control = this.PracticalReport.get(field);
      if (!control) return;

      if (field === 'college') {
        control.setValue([]);
      } else {
        control.setValue('');
      }

      switch (field) {
        case 'course':
          this.CourseList = [];
          this.filteredCourseList = [];
          break;
        case 'college':
          this.selectedColleges = [];
          this.commaSeparatedColleges = '';
          this.collegeList = [];
          this.filteredCollegeList = [];
          break;
        case 'Exam':
          this.ExamAList = [];
          this.filteredExamAList = [];
          break;
        case 'Branch':
          this.BranchList = [];
          this.filteredBranchList = [];
          break;
      }
    });
    this.updateDownloadButtonVisibility();
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getCollegeName(collegeCode: string): string {
    const c = this.collegeList.find(x => x.CgCode === collegeCode);
    return c ? c.CgName : collegeCode;
  }

  getCourseName(courseCode: string): string {
    const c = this.CourseList.find(x => x.CoCgCoCode === courseCode);
    return c ? c.CoName : courseCode;
  }

  getExamName(examId: string): string {
    const e = this.ExamAList.find(x => x.EmId === examId);
    return e ? e.EmName : examId;
  }

  getSessionName(sessionId: string): string {
    const s = this.sessionList.find(x => x.SnNo === sessionId);
    return s ? s.SnName : sessionId;
  }

  getBranchName(branchId: string): string {
    const b = this.BranchList.find(x => x.StrId === branchId);
    return b ? b.StrName : branchId;
  }
}